<template>
  <div class="my-tab">
    <div class="list">
      <template v-if="enabledCustomQuick">
        <div class="list-one" v-for="(item, index) in onLineQuickList" @click="goUrl(item)" :key="'menu-' + index">
          <img :src="item.icon" class="iconImg" />
          <span>{{ item.name }}</span>
        </div>
      </template>
      <template v-else>
        <div class="list-one" @click="linkTo(QuickList[0])" v-if="enabledExhibitionSurvey">
          <img :src="QuickList[0].Icon" class="iconImg" />
          <span>{{ QuickList[0].enName }} </span>
        </div>
        <div class="list-one" @click="linkTo(QuickList[1])" v-if="enabledSupplyDemand">
          <img :src="QuickList[1].Icon" class="iconImg" />
          <span>{{ QuickList[1].enName }} </span>
        </div>
        <div class="list-one" @click="linkTo(QuickList[2])">
          <img :src="QuickList[2].Icon" class="iconImg" />
          <span>{{ QuickList[2].enName }} </span>
        </div>
        <div class="list-one" @click="linkTo(QuickList[3])">
          <img :src="QuickList[3].Icon" class="iconImg" />
          <span>{{ QuickList[3].enName }} </span>
        </div>
        <!-- <div class="list-one" v-for="(item, index) in QuickList" @click="linkTo(item)" :key="index">
        <img :src="item.Icon" class="iconImg" />
        <span>{{ item.enName }} </span>
      </div> -->
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "navTab",
  props: {
    QuickList: {
      type: Array,
      default: function () {
        return [
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/153177aa34ed415cabed56b3a12842cb.png",
            Id: "50352a21-d279-46af-88fa-3520f50f2dc1",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/headlines/3b3c9c7b-716b-47b9-80e3-a87b84d9273a?type=2",
            Name: "展会概况",
            enName: "Overview",
            ShowIndex: "1",
          },
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202011/20201110/799809cd5b604513bdbc170d0582956a.png",
            Id: "b863f0e3-e3a5-47a7-9bd6-dd596115908e",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/headlines/3b3c9c7b-716b-47b9-80e3-a87b84d9273a?type=1",
            Name: "供需发布",
            enName: "Supply & Demand",
            ShowIndex: "2",
          },
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/1b41a378c5c944718dee28e4c917f35f.png",
            Id: "c08120a1-1f12-4b18-b1ea-52cc22fe102c",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/default/3b3c9c7b-716b-47b9-80e3-a87b84d9273a?type=0",
            Name: "展位预览",
            enName: "Floorplans",
            ShowIndex: "3",
          },
          {
            Icon: "https://img.zhanshangxiu.com/showonline/file/202507/20250709/0fb90f5a68244560ac6dfc129b22c997.png",
            Id: "9f19cabf-5055-42ca-8785-87de7226a196",
            ItemId: "abebd606-efd5-41a0-9858-7fbaca72692f",
            Link: "https://m.zhanshangxiu.com/custom-form",
            Name: "注册参观",
            enName: "Register",
            ShowIndex: "4",
          },
        ];
      },
    },
  },
  data() {
    return {
      onLineQuickList: [],
      HGexhibitionList: [
        "63af2701-17c3-4fb1-b826-aca9228adcc3",
        "3bc3ed3d-d84e-40d6-be92-910905ba0576",
        "5fe797f0-a87e-46a6-ae72-48205eda9086",
        "68da03a5-8127-43b0-903c-97ccb982c429",
        "33ffaaa0-6c0d-4878-b96e-d22573d3b038",
      ],
      isHG: false,
    };
  },
  computed: {
    ...mapGetters({
      exonId: "getExhibitionId",
      exhibitionConfig: "getExhibitionConfig",
      exConfig: "getExConfig",
      userInfo: "getUserInfo",
    }),
    exhibitionId() {
      return this.$route.params.id || this.exonId;
    },
    enabledSupplyDemand() {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.feature &&
        this.exhibitionConfig.feature.enabledSupplyDemand
      );
    },
    enabledExhibitionSurvey() {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.feature &&
        this.exhibitionConfig.feature.enabledExhibitionSurvey
      );
    },
    enabledCustomQuick() {
      return (
        this.exhibitionConfig &&
        this.exhibitionConfig.display &&
        this.exhibitionConfig.display.enabledCustomQuick
      );
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      visitToLinkRegister: "register/visitToLinkRegister",
      LinkToHeadLinesTab: "linkTo/LinkToHeadLinesTab",
      LinkToReg: "linkTo/LinkToReg",
      LinkFooter: "linkTo/LinkFooter",
      LinkToMyOrder: "linkTo/LinkToMyOrder",
      graphqlPostByZXS: "en/graphqlPostByZXS",
    }),
    linkTo(item) {
      console.log(item);
      //1 展会概况  2 供需商机 3展位预览 4注册参观
      switch (item.ShowIndex) {
        case "1": {
          // this.$store.commit('setHeadTab','exinfo');
          // this.LinkFooter({url:`/news/${this.exhibitionId}`})
          let opt = {
            url: "/headlinesExinfo",
            actIndex: 2,
          };
          this.LinkToHeadLinesTab(opt);
          break;
        }
        case "2": {
          // this.$store.commit('setHeadTab','needs');
          // this.LinkFooter({url:`/news/${this.exhibitionId}`})

          // this.LinkToMyOrder()
          let opt = {
            url: "/headlinesExinfo",
            actIndex: 0,
          };
          this.LinkToHeadLinesTab(opt);

          break;
        }
        case "3": {
          let opt = {
            url: `/boothView/${this.exhibitionId}`,
          };
          this.LinkFooter(opt);
          // this.$toast('暂未开放，敬请期待')
          break;
        }
        case "4": {
          if (this.exhibitionId == "63af2701-17c3-4fb1-b826-aca9228adcc3") {
            location.href =
              "http://xzt.eastfair.com/EztEnV1/index.html#/home?ExhID=1013&InviteType=Platform&InviteID=0&InviteCode=FShow";
            return;
          }
          this.HGexhibitionList.forEach((c) => {
            if (c.indexOf(this.exhibitionId) != -1) {
              this.isHG = true;
              location.href =
                "http://xzt.eastfair.com/EztEnV1/index.html#/home?ExhID=1013";
            }
          });

          if (
            this.userInfo.inMember.userRole.toUpperCase() != "VISITOR" &&
            !this.isHG
          ) {
            this.$toast("You have already registered");
            return;
          } else {
            this.LinkToReg();
          }
          break;
        }
        default:
          break;
      }
    },
    async init() {
      if (!this.enabledCustomQuick) return;
      let query = `
        query($query:QueryInput!){
          quicklinkQuery{
            query(query:$query){
              items{
                icon
                name
                showIndex
                webUrl
              }
            }
          }
        }
        `;
      let where = {
        Equal: {
          n: "itemId",
          v: this.exonId,
        },
        EqualB: {
          n: "itemType",
          v: "exhibition",
        },
        Equal_lang: {
          n: "langVersion",
          v: "en",
        },
      };
      let order = [
        {
          N: "showIndex",
          v: 1,
        },
      ];
      let opt = {
        queryName: "onLineQuickList",
        query: query,
        variables: {
          query: {
            page: 1,
            size: 30,
            where: JSON.stringify(where),
            order: JSON.stringify(order),
          },
        },
      };
      let data = await this.graphqlPostByZXS(opt);
      let res = JSON.parse(
        JSON.stringify(data.data.quicklinkQuery.query.items)
      );
      this.onLineQuickList = res;
      console.log("this.onLineQuickList", this.onLineQuickList);
    },
    goUrl(e) {
      window.location.href = e.webUrl;
    },
  },
};
</script>

<style scoped>
.my-tab {
  margin-bottom: 0.15rem;
  padding: 0 0.3rem;
}
.list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.list-one {
  display: flex;
  align-items: center;
  width: 3.35rem;
  height: 0.76rem;
  background-color: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding-left: 0.15rem;
  margin-bottom: 0.2rem;
}
.iconImg {
  width: 0.46rem;
  height: 0.46rem;
  margin-right: 0.2rem;
  display: block;
}
.iconfont {
  text-align: center;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  font-size: 30px;
  color: #fff;
}
.list-one span {
  font-size: 0.26rem;
  color: #333;
}
.s0 {
  background-image: linear-gradient(0deg, #22d9bb 0%, #3bf2d1 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s1 {
  background-image: linear-gradient(0deg, #4678ff 0%, #9cb2ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s2 {
  background-image: linear-gradient(0deg, #275aff 0%, #3c91ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s3 {
  background-image: linear-gradient(0deg, #ffa01a 0%, #ffbf1f 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s4 {
  background-image: linear-gradient(0deg, #2a9efe 0%, #74d7ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s5 {
  background-image: linear-gradient(0deg, #fb23fb 0%, #ffa2d6 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s6 {
  background-image: linear-gradient(0deg, #ff2468 0%, #ff849e 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s7 {
  background-image: linear-gradient(0deg, #2a9efe 0%, #74d7ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s8 {
  background-image: linear-gradient(0deg, #275aff 0%, #3c91ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s9 {
  background-image: linear-gradient(0deg, #ffa01a 0%, #ffbf1f 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s10 {
  background-image: linear-gradient(0deg, #2a9efe 0%, #74d7ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s11 {
  background-image: linear-gradient(0deg, #fb23fb 0%, #ffa2d6 100%),
    linear-gradient(#ff7439, #ff7439);
}
.s12 {
  background-image: linear-gradient(0deg, #4678ff 0%, #9cb2ff 100%),
    linear-gradient(#ff7439, #ff7439);
}
</style>
